import EnvironmentOutlined from "@ant-design/icons/lib/icons/EnvironmentOutlined";
import MailOutlined from "@ant-design/icons/lib/icons/MailOutlined";
import PhoneOutlined from "@ant-design/icons/lib/icons/PhoneOutlined";
import Col from "antd/es/col";
import Row from "antd/es/row";
import "../styles/AboutUs.scss";

function AboutUs() {
  return (
    <div className="p-2" style={{ boxSizing: "border-box" }}>
      <Row style={{ fontSize: 16, fontWeight: "600", color: "#08F" }} className="mt-2 mb-4">
        TOPUTII Shop xin kính chào quý khách.{" "}
      </Row>
      <Row className="mt-3 mb-3" style={{ fontStyle: "italic" }}>
        Nếu quý khách có thắc mắc hoặc góp ý về dịch vụ của chúng tôi, vui lòng liên hệ với chúng
        tôi theo các thông tin dưới đây. Chúng tôi sẽ phản hồi trong thời gian sớm nhất. Trân trọng!
      </Row>
      <Row>
        <Col sm={6} md={4} lg={3}>
          <EnvironmentOutlined style={{ color: "#08F" }} /> Địa chỉ:
        </Col>
        <Col sm={18} md={20} lg={21}>
          ĐT310, Thiện Kế - Bình Xuyên - Vĩnh Phúc - Việt Nam
        </Col>
      </Row>
      <Row className="mt-3 mb-3">
        <Col sm={6} md={4} lg={3}>
          <PhoneOutlined style={{ color: "#08F" }} /> SĐT:
        </Col>
        <Col sm={18} md={20} lg={21} style={{ fontWeight: "bold" }}>
          <a href="tel:0836112000">0836112000</a>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={4} lg={3}>
          <MailOutlined style={{ color: "#08F" }} /> Email:
        </Col>
        <Col sm={18} md={20} lg={21}>
          <a href="mailto:nguyenhungcuong1206@gmail.com">nguyenhungcuong1206@gmail.com</a>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d480.6646425222403!2d105.68367628519617!3d21.335852717263847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3134e5006635aed1%3A0x144a8108a1fea15!2zVHLDoCBz4buvYSB0b3B1dGlp!5e1!3m2!1svi!2s!4v1766464765478!5m2!1svi!2s"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
export default AboutUs;
